import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useAuth } from "../hooks/useAuth";
import { Navigate, useNavigate } from "react-router-dom";
import Logo from "./homepage/images/logo.png";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { apiInst, updateApiBaseUrl } from "../hooks/apiHandler";

const API_BY_COUNTRY = {
  // developer: "http://localhost:1717/v1",
  // developer: "http://mapi.dev.miira.ca/v1",
  Canada: "https://api.miirapos.com/v1",
  India: "https://api.in.miirapos.com/v1",
};

export const LoginPage = () => {
  const { login, user } = useAuth();
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const navigate = useNavigate();
  const [userZone, setUserZone] = useState("");
  const [region, setRegion] = useState("Canada");


  useEffect(() => {
    // Detect user's time zone and set region accordingly
    let detectedRegion = window.localStorage.getItem("api_region");
    
    if (detectedRegion) {
      setRegion(detectedRegion);
    } else {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    detectedRegion = timeZone.startsWith("Asia/")
      ? "India"
      : "Canada";
    setRegion(detectedRegion);
    }
    console.log("Detected Region:", detectedRegion);
    const newUrl = API_BY_COUNTRY[detectedRegion];
    updateApiBaseUrl(newUrl, detectedRegion);

  }, []);



  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!agreedToTerms) return;
    const data = new FormData(event.currentTarget);
    let resp = await login({
      email: data.get("email"),
      password: data.get("password")
    });
    if (resp) {
      return <Navigate to="/store" replace />;
    } else {
      return <Navigate to="/login" replace />;
    }
  };

  const handleRegionChange = (event) => {
    const selectedRegion = event.target.value;

    const newUrl = API_BY_COUNTRY[selectedRegion];
    setRegion(selectedRegion);
    updateApiBaseUrl(newUrl, selectedRegion);
  };

  apiInst.interceptors.request.use((config) => {
    console.log("➡ API CALL:", config.baseURL);
    return config;
  });



  if (user) {
    return <Navigate to="/store" replace />;
  }


  return (
    <>

      <ArrowBackIcon sx={{ color: '#222', marginLeft: '25px', marginTop: '25px', borderRadius: '100%', border: '1px solid #222', fontSize: '32px' }}
        onClick={() => navigate("/")}></ArrowBackIcon>
      <Container component="main" maxWidth="xs">

        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}
        >
          {/* <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
          <LockOutlinedIcon />
        </Avatar> */}
          <img src={Logo} alt="miirapos_logo" width='120px' onClick={() => navigate("/")}></img>
          <Typography component="h1" variant="h5">
            Log In
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel id="region-label">Region</InputLabel>
              <Select
                labelId="region-label"
                value={region}
                label="Region"
                onChange={handleRegionChange}
              >
                {Object.keys(API_BY_COUNTRY).map((country) => (
                  <MenuItem key={country} value={country}>
                    {country}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <FormControlLabel
              control={
                <Checkbox
                  value="agree"
                  color="primary"
                  checked={agreedToTerms}
                  onChange={(e) => setAgreedToTerms(e.target.checked)}
                />
              }
              label={
                <Typography variant="body2">
                  I agree to the&nbsp;
                  <Link href="/terms" target="_blank" rel="noopener noreferrer">
                    Terms & Conditions
                  </Link>
                </Typography>
              }
              sx={{ mt: 2 }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={!agreedToTerms}
            >
              Log In
            </Button>
            <Grid container>
              <Grid item>
                <Link href="/register" variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </>
  );
};
